import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const builder = RepositoryFactory.get("builder");

export default {
  updatePages({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.updatePages(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  async getSuitesData({}, payload) {
    const response = await builder.getSuitesData(payload);
    this.$store.commit("scope/SET_SUITE_DATA", response.data.data);
  },
  getTasklist({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getTasklist(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPages({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getPages(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getRoles({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getRoles(payload);
        resolve(data.data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getProjectUserStories({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getProjectUserStories(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getUserStories({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getUserStories(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAssignTask({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getAssignTask(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  paginatedTasks({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.paginatedTasks(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  saveRequirements({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.saveRequirements(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPagesComponents({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await builder.getPagesComponents(payload);
        console.log(data, "asctionn");
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
